import React, { useEffect } from "react";
import { CalendarPage } from "@hedgefund/shared";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import { getMonthlyMeeting } from "../actions";
const MonthlyMeetingDetail = ({}) => {
  const dispatch = useDispatch();
  const currentMonth = moment().month() + 1;
  const currentYear = moment().year();

  useEffect(() => {
    dispatch(getMonthlyMeeting(currentMonth, currentYear));
  }, [dispatch]);
  const meeting = useSelector((state) => state.meetingDetails);
  const {
    meetingData,
    // loading
  } = meeting;
  return <CalendarPage meetingData={meetingData} />;
};

export default MonthlyMeetingDetail;
